<template>
  <div>
    <a-modal
      width="540px"
      :title="person==='me'?'认领需求':'指派需求'"
      :visible="visible"
      :ok-button-props="{ props: { loading: loading } }"
      @cancel="onClose"
      @ok="onOk"
    >
      <div v-if="person==='me'">
        本人认领需求后可以快速跳过需求倒计时
        识别到您为{{ isPo?'产品PO':'技术经理' }}角色，将为您自动填充
      </div>
      <div v-else>
        <a-form-model :form="formData" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :model="formData">
          <a-row :gutter="24">
            <a-form-model-item label="产品PO" prop="po">
              <a-select v-model="formData.po" mode="multiple" allow-clear placeholder="请选择产品PO" :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in brPoList" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="技术经理" prop="technicalManager">
              <a-select v-model="formData.technicalManager" mode="multiple" allow-clear placeholder="请选择技术经理" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-row>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { updateBusinessRequirementSimpleField } from '@/api/business/requirement';

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      person: 'me',
      brInfo: {},
      formData: {
        po: [],
        technicalManager: []
      }
    };
  },
  computed: {
    brPoList() {
      const orgList = this.$store.getters.globalConfig('br_po', []);
      return orgList.map(item => {
        return {
          nickname: item.nickname,
          id: item.user_id
        };
      });
    },
    isPo() {
      const userId = this.$store.state.userInfo.id;
      const use = this.brPoList.find(item => item.id === userId);
      return !!use;
    },
    userData() {
      return this.$store.state.allUsers || [];
    }
  },
  methods: {
    onOpen(person, brInfo) {
      this.brInfo = JSON.parse(JSON.stringify(brInfo));
      this.formData = {
        po: this.brInfo.po || [],
        technicalManager: this.brInfo.technicalManager || []
      };
      this.person = person;
      this.visible = true;
    },

    onClose() {
      this.visible = false;
    },
    onOk() {
      const _data = {
        po: [],
        technicalManager: []
      };
      if (this.person === 'me') {
        // 认领
        if (this.isPo) {
          _data.po = [this.$store.state.userInfo.id];
        }
        if (!this.isPo) {
          _data.technicalManager = [this.$store.state.userInfo.id];
        }
      } else {
        // 指派
        _data.po = this.formData.po || [];
        _data.technicalManager = this.formData.technicalManager || [];
      }

      if (_data.po.length === 0 && _data.technicalManager.length === 0) {
        this.$message.error('请选择产品PO或技术经理');
        return;
      }
      this.loading = true;
      updateBusinessRequirementSimpleField({ id: this.brInfo.id, fields: { po: JSON.stringify(_data.po), technicalManager: JSON.stringify(_data.technicalManager) }})
        .then(() => {
          this.$emit('saveOk', this.person === 'me' ? '认领' : '指派', _data);
          // this.$message.success('保存成功');
          this.onClose();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}
</style>

